import { Component, OnDestroy } from '@angular/core';
import { Breadcrumb } from '@app/models/breadcrumb.model';
import { ActivatedRoute } from '@angular/router';
import { BreadcrumbService } from '@app/shared/breadcrumbs/breadcrumbs.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-integration-slack',
  templateUrl: './integration-slack.component.html',
  styleUrls: ['./integration-slack.component.css']
})
export class IntegrationSlackComponent implements OnDestroy {

  breadcrumb: Breadcrumb;

  constructor(
    private breadcrumbService: BreadcrumbService,
    public route: ActivatedRoute
  ) {
    this.breadcrumb = this.breadcrumbService.init(this.route);

  }

  ngOnDestroy() {
    this.breadcrumbService.remove(this.breadcrumb);
  }

  // This can be removed when the OAuth redirect URL on our Slack app has been updated to use app.frankli.io
  getInstallationUrl(): string {
    return environment.production ?
      'https://app.frankli.io/slack/install' :
      '/slack/install';
  }
}


